import { GuardedComponent } from '../components/guarded-component';
import { CreateOfficePage } from '../features/offices/create-office/create-office.page';
import { EditOfficePage } from '../features/offices/create-office/edit-office.page';
import { OfficeDetailsPage } from '../features/offices/office-details/office-details.page';
import { OfficesPage } from '../features/offices/offices.page';
import { UserPermissionName } from '../models/user-permission-name';

export const OfficesRoute = {
  path: '/offices',
  children: [
    {
      index: true,
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_OFFICE]} showPermissionError>
          <OfficesPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'details/:id',
      name: 'Profile',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_OFFICE]} showPermissionError>
          <OfficeDetailsPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'create',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.ADD_OFFICE]} showPermissionError>
          <CreateOfficePage />
        </GuardedComponent>
      ),
    },
    {
      path: 'edit/:officeID',
      name: 'Edit',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.EDIT_OFFICE]} showPermissionError>
          <EditOfficePage />
        </GuardedComponent>
      ),
    },
  ],
};
